var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkModeBlackOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4094 13.2809C7.33276 10.2043 6.71744 5.69195 8.3583 2C7.12765 2.41022 6.10216 3.23066 5.07662 4.2562C0.974459 8.35837 0.974459 14.9219 5.07662 19.024C9.17878 23.1262 15.5371 22.9211 19.6392 18.8189C20.6648 17.7934 21.4853 16.7678 21.8955 15.5372C17.9985 16.9729 13.486 16.3576 10.4094 13.2809Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4094 13.2809C7.33276 10.2043 6.71744 5.69195 8.3583 2C7.12765 2.41022 6.10216 3.23066 5.07662 4.2562C0.974459 8.35837 0.974459 14.9219 5.07662 19.024C9.17878 23.1262 15.5371 22.9211 19.6393 18.8189C20.6648 17.7934 21.4853 16.7678 21.8955 15.5372C17.9985 16.9729 13.486 16.3576 10.4094 13.2809Z",
    stroke: "#212D4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModeBlackOutline);
export default __webpack_public_path__ + "static/media/dark-mode-black-outline.e4d281f367064a6c8d564e676578a1ec.svg";
export { ForwardRef as ReactComponent };